import React from "react";
import img1 from "../../../Assets/Home/about1.png";

const PhoneRingIcon = () => (
  <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-white flex items-center justify-center shadow-md flex-shrink-0">
    <svg
      className="w-5 h-5 sm:w-6 sm:h-6 text-[#e8341c]"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 011 1V20a1 1 0 01-1 1C10.61 21 3 13.39 3 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.45.57 3.58a1 1 0 01-.25 1.01l-2.2 2.2z" />
      <path
        d="M15 1a9 9 0 019 9"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M15 5a5 5 0 015 5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  </div>
);

const PiAbout = () => {
  return (
    <div className="bg-[#f5f0e8] w-full px-4 sm:px-6 lg:px-8 py-10 sm:py-12">
      {/* About Section */}
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-10 items-start">
          {/* Left Column */}
          <div className="space-y-4 sm:space-y-5">
            {/* Section label */}
            <div className="mb-2 sm:mb-4">
              <span className="text-[10px] sm:text-xs md:text-sm font-bold tracking-[0.2em] text-gray-800 uppercase border-b-2 border-[#e8341c] pb-1 font-krona inline-block">
                ABOUT US
              </span>
            </div>

            {/* Heading */}
            <h2
              className="text-gray-900 font-extrabold font-krona 
                text-xl sm:text-2xl md:text-4xl lg:text-[45px] 
                leading-tight sm:leading-[1.4] lg:leading-[1.45]"
            >
              Where Mining Expertise
              <br className="hidden sm:block" />
              Meets Engineering
              <br className="hidden sm:block" />
              Excellence
            </h2>

            {/* Body text */}
            <p className="text-gray-600 text-xs sm:text-sm leading-relaxed max-w-full lg:max-w-[540px]">
              Recognized among India's top MSMEs and trusted by industry
              leaders, we deliver end-to-end projects— from precision surveying
              to eco-friendly rehabilitation— backed by 4M+ tons of
              incident-free mineral extraction and 100% statutory compliance.
              Our success stems from a unique fusion of cutting-edge technology,
              in-house operational scale, and client-centric agility, ensuring
              tailored solutions for every challenge.
            </p>
          </div>

          {/* Right Column */}
          <div className="flex flex-col gap-4 sm:gap-5 lg:gap-6 mt-4 lg:mt-0">
            {/* Top description */}
            <p className="text-gray-700 text-xs sm:text-sm md:text-base font-krona leading-relaxed font-medium">
              Prudence India Mega Projects Pvt Ltd stands as a pioneer in
              integrated mining and infrastructure solutions, with 25+ years of
              technical expertise
            </p>

            {/* Image */}
            <div className="rounded-lg overflow-hidden shadow-md w-full h-[250px] sm:h-[280px] md:h-[320px] lg:h-[340px]">
              <img
                src={img1}
                alt="About Prudence India"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
          </div>
        </div>
      </div>

      {/* CTA Banner */}
      <div className="max-w-7xl mx-auto mt-6">
        <div
          className="rounded-lg sm:rounded-xl flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-5 lg:gap-6 px-4 sm:px-6 lg:px-10 py-5 sm:py-6"
          style={{
            background:
              "linear-gradient(135deg, #1a0a04 0%, #2d1206 40%, #1a0604 100%)",
            boxShadow: "0 8px 32px rgba(0,0,0,0.35)",
          }}
        >
          {/* Left text */}
          <span
            className="text-white font-bold text-base sm:text-lg lg:text-base tracking-wide text-center sm:text-left"
            style={{ fontFamily: "'Barlow Condensed', 'Oswald', sans-serif" }}
          >
            To partner with us as your Mines Developer and operator (MDO)
          </span>

          {/* Divider line - hidden on mobile */}
          <div className="hidden sm:block w-px h-8 bg-white/20 mx-1 lg:mx-2" />

          {/* Phone icon and call section - stacked on mobile, row on larger screens */}
          <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-4">
            {/* Phone icon */}
            <PhoneRingIcon />

            {/* Call us text */}
            <div className="flex flex-col sm:flex-row items-center gap-1 sm:gap-2 lg:gap-3">
              <span className="text-white/80 text-xs sm:text-sm font-medium tracking-wide">
                call us on
              </span>
              <span
                className="text-[#e8341c] font-black text-xl sm:text-2xl lg:text-3xl tracking-widest whitespace-nowrap"
                style={{
                  fontFamily: "'Barlow Condensed', 'Oswald', sans-serif",
                  letterSpacing: "0.08em",
                }}
              >
                977 777 4005
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PiAbout;
